import { ChangeEvent, FC } from 'react'

import {
  Dropdown,
  DropdownOption,
  DropdownSizes,
  DropdownValue
} from '@inno-ui/dropdown'
import { BriefcaseLineIcon, PersonLineIcon } from '@inno-ui/icons'
import { useTranslation } from 'react-i18next'

import styles from './SharePickers.module.scss'

interface SharePickersProps {
  busy: boolean
  positionItems: DropdownOption[]
  positionValue: DropdownOption[]
  onPositionsChange: (value: DropdownValue) => void
  peopleItems: DropdownOption[]
  selectedUser: DropdownValue
  isSearchingPeople: boolean
  onPeopleSelect: (value: DropdownValue) => void
  onPeopleSearch: (event: ChangeEvent<HTMLInputElement>) => void
  onPeopleClear: () => void
  onPeopleClose: () => void
}

// the two "add a share" controls — grouped tightly so they read as one
// section, separate from the org toggle above and the shared-with list below
export const SharePickers: FC<SharePickersProps> = ({
  busy,
  positionItems,
  positionValue,
  onPositionsChange,
  peopleItems,
  selectedUser,
  isSearchingPeople,
  onPeopleSelect,
  onPeopleSearch,
  onPeopleClear,
  onPeopleClose
}) => {
  const { t } = useTranslation('translation', { keyPrefix: 'widgets.aiAgent' })

  return (
    <div className={styles.pickerGroup}>
      <Dropdown
        label={t('sharedWithPositionsLabel')}
        icon={BriefcaseLineIcon}
        placeholder={t('positionsSearchPlaceholder')}
        items={positionItems}
        value={positionValue}
        onChange={onPositionsChange}
        multiple
        clearable
        isSearchable
        size={DropdownSizes.M}
        width='100%'
        disabled={busy}
        triggerAutoZIndex
      />

      <Dropdown
        label={t('sharedWithPeopleLabel')}
        icon={PersonLineIcon}
        placeholder={t('searchPlaceholder')}
        items={peopleItems}
        value={selectedUser}
        onChange={onPeopleSelect}
        onSearch={onPeopleSearch}
        onClear={onPeopleClear}
        onClose={onPeopleClose}
        isSearchable
        isSearching={isSearchingPeople}
        size={DropdownSizes.M}
        width='100%'
        disabled={busy}
        nothingFoundText={t('notSharedYet')}
        triggerAutoZIndex
      />
    </div>
  )
}
